module.exports = __webpack_public_path__ + "static/media/SevenG_Universe.e28ff4d5.png";